import { render, staticRenderFns } from "./SectionLabel.vue?vue&type=template&id=dc97784c&scoped=true&"
import script from "./SectionLabel.vue?vue&type=script&lang=js&"
export * from "./SectionLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc97784c",
  null
  
)

export default component.exports